/**
 * Datei-Download und Base64-Umwandlung — Ersatz für die `saveAsFile`-JS-Funktion
 * und `Convert.ToBase64String` aus dem Altclient.
 */

function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

/** Lädt die übergebenen Bytes als Datei herunter. */
export function saveAs(fileName: string, bytes: Uint8Array): void {
  // Kopie in einen eigenen ArrayBuffer: ein Uint8Array kann auch über einem
  // SharedArrayBuffer liegen und ist dann kein gültiger BlobPart.
  const buffer = new ArrayBuffer(bytes.byteLength);
  new Uint8Array(buffer).set(bytes);

  const blob = new Blob([buffer], { type: 'application/octet-stream' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.download = fileName;
  link.href = url;
  // Der Link muss im Dokument hängen, damit Firefox den Klick auswertet.
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}

export function base64ToBytes(base64: string): Uint8Array {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  return bytes;
}

export function bytesToBase64(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary);
}

/** `view_export_{ddMMyyyy}_{HHmmss}.xlsx` — Dateiname des Excel-Exports. */
export function buildExportFileName(now: Date = new Date()): string {
  const date = `${pad(now.getDate())}${pad(now.getMonth() + 1)}${now.getFullYear()}`;
  const time = `${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
  return `view_export_${date}_${time}.xlsx`;
}
